import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';

/**
 * Bloquea las vistas de Clientes para un cliente Final: no tiene clientes
 * debajo ni puede crearlos (`setTipoCliente` del crear/editar no le ofrece
 * ningún tipo), así que el listado le muestra una tabla vacía y el crear le
 * ofrece un formulario que no puede completar.
 *
 * Va como guard además de esconder la solapa en el menú porque las rutas se
 * alcanzan escribiendo la URL. El chequeo por tipo de cliente no lo cubre
 * `tienePermiso`, que solo mira las acciones del rol.
 */
@Injectable({
  providedIn: 'root',
})
export class ClientesGuard {
  private helper = inject(HelperService);
  private router = inject(Router);

  canActivate(): boolean | UrlTree {
    if (!this.helper.esClienteFinal()) {
      return true;
    }
    this.helper.notifWarn('No tenés acceso a la vista de Clientes');
    return this.router.parseUrl('/mapa');
  }
}
